import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { angularProviderHOC } from '../../../common/react/AngularProviderHOC';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { BrowserTitleService } from '../../../ts/services/BrowserTitleService';
import { Telemetry } from '../../../ts/services/TelemetryService';
import { ServiceLocator } from '../../ServiceLocator';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedQueryParamUpdateProvider } from '../RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { ConnectedBackgroundJobsSpace } from './ConnectedBackgroundJobsSpace';

export interface BackgroundJobsSpaceProviderAngularProps {
  readonly browserTitleService: BrowserTitleService;
  readonly telemetry: Telemetry;
}

export interface BackgroundJobsSpaceProviderOwnProps extends ReactDirectiveProps{
  readonly siteName: string;
  readonly routeLocationSearch: string;
  readonly routeLocationPath: string;
}

export type BackgroundJobsSpaceProviderProps =
  BackgroundJobsSpaceProviderAngularProps & BackgroundJobsSpaceProviderOwnProps;

export const BackgroundJobsSpaceProviderComponent: React.FunctionComponent<BackgroundJobsSpaceProviderProps> = props => {

  props.browserTitleService.setTitleWithTranslatedSpace({ translatedSpaceName: Messages.backgroundJobs() });

  const spaceInfo: SpaceInfo = {
    item: SpaceItemForNonEntitySpace,
    spaceType: 'backgroundJobs',
    subspaceName: undefined,
  };

  return (
    <ConnectedSpaceInfoProvider spaceInfo={spaceInfo}>
      <ConnectedQueryParamUpdateProvider
          shouldUpdateFilters={true}
          shouldUpdateContentTypes={false}
          shouldUpdateBreadcrumbs={false}
          shouldUpdateSort={true}
          routeLocationSearch={props.routeLocationSearch}
          routeLocationPath={props.routeLocationPath}>
        <ConnectedBackgroundJobsSpace {...props} />
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};

export namespace BackgroundJobsSpaceProviderAngularProvider {
  function getAngularServicesWithServiceLocator(): BackgroundJobsSpaceProviderAngularProps {
    return {
      telemetry: ServiceLocator.get('TelemetryService'),
      browserTitleService: ServiceLocator.get('BrowserTitleService')
    };
  }

  function selectPropsFromAngularServices(angularServices: BackgroundJobsSpaceProviderAngularProps) {
    return angularServices;
  }

  export const HOC = angularProviderHOC<BackgroundJobsSpaceProviderOwnProps, BackgroundJobsSpaceProviderAngularProps, BackgroundJobsSpaceProviderAngularProps>({
    getAngularServicesWithServiceLocator,
    selectPropsFromAngularServices
  });
}

export const BackgroundJobsSpaceProvider = BackgroundJobsSpaceProviderAngularProvider.HOC(BackgroundJobsSpaceProviderComponent);
